(() => {
  const targetPage = () => document.querySelector('.section-cv-lorex-cnx3-turret-purchase');
  const usesInnerScroller = () => {
    const page = targetPage()?.closest('.page-wrapper');
    return page && ['auto', 'scroll'].includes(getComputedStyle(page).overflowY);
  };

  if (window.Shopify?.designMode) {
    let selectedEditorElement = null;
    let editorFrame = 0;
    let editorScrollController = null;
    let editorCompletionTimer = 0;
    const stopEditorScrollWatch = () => {
      editorScrollController?.abort();
      editorScrollController = null;
      clearTimeout(editorCompletionTimer);
      editorCompletionTimer = 0;
    };
    const revealEditorSelection = () => {
      if (editorFrame) return;
      editorFrame = requestAnimationFrame(() => {
        editorFrame = 0;
        const page = targetPage()?.closest('.page-wrapper');
        if (!selectedEditorElement?.isConnected || !page?.contains(selectedEditorElement)) return;
        const scroller = usesInnerScroller() ? page : document.scrollingElement;
        if (scroller === page) document.scrollingElement.scrollTo({ top: 0, behavior: 'instant' });
        const rect = selectedEditorElement.getBoundingClientRect();
        const top = Math.max(0, document.querySelector('.cv-header__surface')?.getBoundingClientRect().bottom || 0) + 16;
        const bottom = window.innerHeight - 16;
        const fits = rect.height <= bottom - top;
        if (rect.height && (rect.top < top || rect.top >= bottom || (fits && rect.bottom > bottom))) {
          scroller.scrollTo({ top: scroller.scrollTop + rect.top - top, behavior: 'instant' });
        }
      });
    };
    const selectEditorElement = (event) => {
      if (!targetPage() || !(event.target instanceof HTMLElement) || !event.target.closest('main')) return;
      stopEditorScrollWatch();
      selectedEditorElement = event.target;
      editorScrollController = new AbortController();
      document.addEventListener('scrollend', revealEditorSelection, { signal: editorScrollController.signal });
      editorCompletionTimer = setTimeout(() => {
        stopEditorScrollWatch();
        revealEditorSelection();
      }, 700);
      revealEditorSelection();
    };
    const deselectEditorElement = (event) => {
      if (selectedEditorElement === event.target || event.target.contains?.(selectedEditorElement)) {
        selectedEditorElement = null;
        stopEditorScrollWatch();
      }
    };
    document.addEventListener('shopify:section:select', selectEditorElement);
    document.addEventListener('shopify:block:select', selectEditorElement);
    document.addEventListener('shopify:section:deselect', deselectEditorElement);
    document.addEventListener('shopify:block:deselect', deselectEditorElement);
    document.addEventListener('shopify:section:unload', deselectEditorElement);
  }

  document.addEventListener('focusin', (event) => {
    const focused = event.target;
    if (!targetPage() || !(focused instanceof HTMLElement)
      || !focused.matches('a, button, input, select, textarea, summary')
      || !focused.matches(':focus-visible') || !focused.closest('main, .cv-premium-footer')
      || focused.closest('dialog')) return;
    requestAnimationFrame(() => {
      if (document.activeElement !== focused || !focused.isConnected) return;
      const control = focused.matches('input[type="radio"]') ? focused.labels?.[0] : focused;
      if (!control) return;
      const innerScroller = usesInnerScroller() ? targetPage()?.closest('.page-wrapper') : null;
      if (innerScroller) document.scrollingElement.scrollTo({ top: 0, behavior: 'instant' });
      const rect = control.getBoundingClientRect();
      const headerBottom = document.querySelector('.cv-header__surface')?.getBoundingClientRect().bottom || 0;
      if (rect.height && (rect.top < Math.max(0, headerBottom) + 8 || rect.bottom > window.innerHeight - 8)) {
        if (innerScroller) {
          innerScroller.scrollTo({ top: innerScroller.scrollTop + rect.top - (window.innerHeight - rect.height) / 2, behavior: 'instant' });
        } else {
          control.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'instant' });
        }
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (!targetPage() || !(event.target instanceof Element)) return;
    const chat = event.target.closest('clearvero-chat');
    if (!chat) return;
    const opening = event.target.closest('.cv-launcher');
    const closing = event.target.closest('.cv-close');
    if (!opening && !closing) return;
    requestAnimationFrame(() => {
      if (targetPage() && chat.isConnected && usesInnerScroller()) document.scrollingElement.scrollTo({ top: 0, behavior: 'instant' });
    });
    setTimeout(() => {
      if (!chat.isConnected || !targetPage()) return;
      const focusTarget = opening && chat.dataset.open === 'true'
        ? chat.querySelector('.cv-close')
        : closing && chat.dataset.open === 'false' ? chat.querySelector('.cv-launcher') : null;
      focusTarget?.focus({ preventScroll: true });
      if (focusTarget && usesInnerScroller()) document.scrollingElement.scrollTo({ top: 0, behavior: 'instant' });
    }, opening ? 200 : 0);
  });

  document.addEventListener('keydown', (event) => {
    if (!targetPage()) return;
    const chat = document.querySelector('clearvero-chat[data-open="true"]');
    const panel = chat?.querySelector('.cv-panel[data-open="true"]');
    if (!panel) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      chat.querySelector('.cv-close')?.click();
      return;
    }
    if (event.key !== 'Tab') return;
    const controls = [...panel.querySelectorAll('button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), a[href], [tabindex="0"]')]
      .filter((element) => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && !element.closest('[hidden], [inert]'));
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (!first) return;
    const outside = !panel.contains(document.activeElement);
    if (outside || (event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
      event.preventDefault();
      event.stopPropagation();
      (event.shiftKey ? last : first).focus({ preventScroll: true });
    }
  }, true);

  const initFaq = (root = document) => {
    root.querySelectorAll('[data-cv-lorex-cnx3-turret-faq]:not([data-cv-lorex-cnx3-turret-ready])').forEach((list) => {
      list.dataset.cvLorexCnx3TurretReady = 'true';

      const syncExpandedState = (details) => {
        const summary = details.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      };

      list.querySelectorAll('details').forEach(syncExpandedState);

      list.addEventListener('keydown', (event) => {
        const summary = event.target.closest('summary');
        if (!summary || !list.contains(summary) || !['Enter', ' ', 'Spacebar'].includes(event.key)) return;

        const details = summary.parentElement;
        if (!(details instanceof HTMLDetailsElement)) return;

        event.preventDefault();
        details.open = !details.open;
        syncExpandedState(details);
      });

      list.addEventListener('toggle', (event) => {
        const opened = event.target;
        if (!(opened instanceof HTMLDetailsElement)) return;

        syncExpandedState(opened);
        if (!opened.open || list.dataset.multiple === 'true') return;

        list.querySelectorAll('details[open]').forEach((item) => {
          if (item !== opened) item.open = false;
        });
      }, true);
    });
  };

  const init = (root = document) => {
    initFaq(root);
    const page = targetPage()?.closest('.page-wrapper');
    const chat = document.querySelector('clearvero-chat');
    if (page && chat && chat.parentElement !== page) page.append(chat);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
